import React from 'react';
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

interface Props {
    dataCy?: string;
    href?: string;
    action?: () => void;
    endIcon?: React.ReactNode;
    startIcon?: React.ReactNode;
    className?: string;
    disabled?: boolean;
    children: React.ReactNode;
    type?: 'submit';
}

const BlueButton = (props: Props) => {
    const classes = useStyles();
    const { dataCy, href, action, endIcon, startIcon, className, disabled = false, type, children } = props;

    return (
        <>
            {!!action ? (
                <Button
                    data-cy={dataCy}
                    type={!!type ? type : undefined}
                    variant='contained'
                    color='primary'
                    onClick={action}
                    startIcon={!!startIcon ? startIcon : null}
                    endIcon={!!endIcon ? endIcon : null}
                    disabled={disabled}
                    className={[classes.button, className].join(' ')}
                >
                    {children}
                </Button>
            ) : (
                href && <Button
                    data-cy={dataCy}
                    variant='contained'
                    color='primary'
                    component={Link}
                    to={href}
                    startIcon={!!startIcon ? startIcon : null}
                    endIcon={!!endIcon ? endIcon : null}
                    className={[classes.button, className].join(' ')}
                >
                    {children}
                </Button>
            )}
        </>
    );
}

export default BlueButton;

const useStyles = makeStyles<Theme>((theme) =>
    createStyles({
        button: {
            padding: theme.spacing(0.5, 5),
            fontSize: theme.typography.pxToRem(16),
            fontWeight: theme.typography.fontWeightBold,
            borderRadius: 35,
            textTransform: "initial",
        }
    }))